import FileDownloadIcon from '@mui/icons-material/FileDownloadOutlined'

import { JobMutationArgs, JobMutationTrigger } from 'common/contexts/types'
import { useExportJobContext } from 'common/contexts/useExportJobContext'

interface ICSVExportButton {
  mutationTrigger: JobMutationTrigger
  exportParams: JobMutationArgs
  fileName?: string
}

const CSVExportButton = ({
  mutationTrigger,
  exportParams,
  fileName
}: ICSVExportButton) => {
  const { isExporting, createDataExportJob } = useExportJobContext()

  return (
    <div className='flex leading-6'>
      <button
        className={[
          'flex items-center',
          'font-medium leading-6 text-gray-700',
          'disabled:opacity-30'
        ].join(' ')}
        onClick={() =>
          createDataExportJob(mutationTrigger, exportParams, fileName, '.csv')
        }
        disabled={isExporting}
      >
        <FileDownloadIcon />
        <div className='ml-1'>Export Data</div>
      </button>
    </div>
  )
}

export default CSVExportButton
